import React from "react";
import { LuSearch, LuSearchX } from "react-icons/lu";
import { Merge } from "type-fest";

import { css, cx } from "#styled-system/css";

export function SearchButton({
  className,
  open,
  ...properties
}: Merge<React.ComponentProps<"button">, { children?: never; open?: boolean }>) {
  return (
    <button
      {...properties}
      className={cx(
        css({
          backgroundColor: "white",
          borderColor: "#E4E4E7",
          borderRadius: "6px",
          borderStyle: "solid",
          borderWidth: "1px",
          color: "#18181B",
          cursor: "pointer",
          padding: "11px",
          transition: "filter 0.25s ease-in-out, transform 0.1s ease-in",
          _active: { filter: "brightness(0.95)", transform: "scale(0.975)" },
          _disabled: { cursor: "not-allowed", opacity: 0.5 },
          _focus: { filter: "brightness(0.975)" },
          _hover: { filter: "brightness(0.975)" },
        }),
        className,
      )}
    >
      {open ? <LuSearchX /> : <LuSearch />}
    </button>
  );
}
